export default {
  namespaced: true,
  state: {
    productsList: [],
    cartIsOpen: false,
    cartIsDisabled: true, // 商品のロードが終わるまでカートを開かない
    selectItemIsOpen: false,
    currentMonth: 0,
    requestData: {
      creditCardId: 0,
      nselectionOrderList: [],
      walletAmount: 0
    },
    cartCount: 0,
    totalPrice: 0,
    totalPoint: 0,
    wallet: {
      useWallet: 0, // 使用するウォレット
      usePurchasePoint: 0, // 使用するお買い物ポイント
      selectWalletType: 'NO_USE',
      inputWallet: 0,
      shipmentFee: 0,
      useWalletBillAmount: 0,
    },
    detailData: {
      paymentData: {
        paymentMethod: '',
        paymentMethodName: ''
      },
      creditData: {
        cardBrand: '',
        cardNo: '',
        creditCardId: 0,
        expireYearMonth: null,
        expired: false,
        holderName: '',
        selected: false,
        sameWithBc001: false,
      },
      // deliveryTimeData: {
      //   deliveryTimeId: null,
      //   deliveryTimeName: '',
      // },
    },
    confirm: {
      shipmentFee: 0,
    }
  },
  getters: {
    productsList: state => state.productsList,
    cartIsOpen: state => state.cartIsOpen,
    cartIsDisabled: state => state.cartIsDisabled,
    selectItemIsOpen: state => state.selectItemIsOpen,
    currentMonth: state => state.currentMonth,
    requestData: state => state.requestData,
    nselectionOrderList: state => state.requestData.nselectionOrderList,
    cartCount: state => state.cartCount,
    totalPrice: state => state.totalPrice,
    totalPoint: state => state.totalPoint,
    // wallet関連
    walletAmount: state => state.requestData.walletAmount,
    useWallet: state => state.wallet.useWallet,
    usePurchasePoint: state => state.wallet.usePurchasePoint,
    selectWalletType: state => state.wallet.selectWalletType,
    inputWallet: state => state.wallet.inputWallet,
    shipmentFee: state => state.wallet.shipmentFee,
    useWalletBillAmount: state => state.wallet.useWalletBillAmount,
    // 支払い情報関連
    detailData: state => state.detailData,
    // 配送時間
    // deliveryTimeData: state => state.detailData.deliveryTimeData,
    // 支払い方法
    paymentData: state => state.detailData.paymentData,
    // クレジット情報
    creditData: state => state.detailData.creditData,
    // 確認、完了ページ
    confirmShipmentFee: state => state.confirm.shipmentFee,
  },
  mutations: {
    setProductsList(state, products) {
      state.productsList.push(products);
    },
    setCartIsOpen(state, isOpen) {
      state.cartIsOpen = isOpen;
    },
    setCartIsDisabled(state, isDisabled) {
      state.cartIsDisabled = isDisabled;
    },
    setCurrentMonth(state, currentMonth) {
      state.currentMonth = currentMonth;
    },
    setNselectionOrderList(state, order) {
      const index = state.requestData.nselectionOrderList.findIndex(({productId}) => productId === order.productId)
      if(index != -1) {
        state.requestData.nselectionOrderList.splice(index, 1, order)
      } else {
        state.requestData.nselectionOrderList.push(order);
      }
    },
    deleteNselectionOrderList(state, deleteIndex) {
      console.log('deleteNselectionOrderList');
      console.log(deleteIndex);
      console.log(state.requestData.nselectionOrderList[deleteIndex]);
      state.requestData.nselectionOrderList.splice(deleteIndex, 1)
    },
    resetOrderList(state) {
      state.requestData.nselectionOrderList.splice(0, state.requestData.nselectionOrderList.length);
    },
    setRequestDatacreditCardId(state, creditCardId) {
      state.requestData.creditCardId = creditCardId;
    },
    setSelectItemIsOpen(state, isOpen) {
      state.selectItemIsOpen = isOpen;
    },
    setCartCount(state, count) {
      state.cartCount = count;
    },
    setTotalPrice(state, price) {
      state.totalPrice = price;
    },
    setTotalPoint(state, point) {
      state.totalPoint = point;
    },
    // wallet関連
    setWalletAmount(state, walletAmount) {
      state.requestData.walletAmount = walletAmount;
    },
    setUseWallet(state, useWallet) {
      state.wallet.useWallet = useWallet
    },
    setUsePurchasePoint(state, usePurchasePoint) {
      state.wallet.usePurchasePoint = usePurchasePoint;
    },
    setSelectWalletType(state, selectWalletType) {
      state.wallet.selectWalletType = selectWalletType;
    },
    setInputWallet(state, inputWallet) {
      state.wallet.inputWallet = inputWallet;
    },
    setShipmentFee(state, shipmentFee) {
      state.wallet.shipmentFee = shipmentFee;
    },
    setUseWalletBillAmount(state, useWalletBillAmount) {
      state.wallet.useWalletBillAmount = useWalletBillAmount;
    },
    // 支払い情報関連
    // 配送方法
    // setDeliveryTimeId(state, deliveryTimeId) {
    //   state.detailData.deliveryTimeData.deliveryTimeId = deliveryTimeId;
    // },
    //
    // setDeliveryTimeName(state, deliveryTimeName) {
    //   state.detailData.deliveryTimeData.deliveryTimeName = deliveryTimeName;
    // },
    // 支払い方法
    setPaymentMethodName(state, paymentMethodName) {
      state.detailData.paymentData.paymentMethodName = paymentMethodName;
    },
    setPaymentMethod(state, paymentMethod) {
      state.detailData.paymentData.paymentMethod = paymentMethod;
    },
    // クレジット情報
    setCardBrand(state, cardBrand) {
      state.detailData.creditData.cardBrand = cardBrand;
    },
    setCardNo(state, cardNo) {
      state.detailData.creditData.cardNo = cardNo;
    },
    setCreditCardId(state, creditCardId) {
      state.detailData.creditData.creditCardId = creditCardId;
    },
    setExpireYearMonth(state, expireYearMonth) {
      state.detailData.creditData.expireYearMonth = expireYearMonth;
    },
    setExpired(state, expired) {
      state.detailData.creditData.expired = expired;
    },
    setHolderName(state, holderName) {
      state.detailData.creditData.holderName = holderName;
    },
    setSelected(state, selected) {
      state.detailData.creditData.selected = selected;
    },
    setSameWithBc001(state, sameWithBc001) {
      state.detailData.creditData.sameWithBc001 = sameWithBc001;
    },
    // 確認、完了ページ
    setConfirmShipmentFee(state, shipmentFee) {
      state.confirm.shipmentFee = shipmentFee;
    },
  },
  actions: {
    initializedProductsList({commit, state}) {
      state.productsList.splice(0, state.productsList.length);
    },
    deleteProduct({commit}, { deleteIndex }) {
      commit('deleteNselectionOrderList', deleteIndex);
    },
    calcCartCount({ commit, state }, { status }) {
      let amount = state.cartCount;
      if(status == 'add') {
        amount = amount + 1;
      }
      if(status == 'delete') {
        amount = amount - 1;
      }
      commit('setCartCount', amount);
    },
    calcTotalPoint({ commit}, { point, reset }) {
      if(reset) return commit('setTotalPoint', 0);
      commit('setTotalPoint', point)
    },
    commitDeliveryTimeData({commit}, { deliveryTimeId, deliveryTimeName }) {
      commit('setDeliveryTimeId', deliveryTimeId);
      commit('setDeliveryTimeName', deliveryTimeName);
    },
    commitUserDetailPaymentData({commit}, { paymentMethodName, paymentMethod }) {
      commit('setPaymentMethodName', paymentMethodName);
      commit('setPaymentMethod', paymentMethod);
    },
    commitCreditData({commit}, { cardBrand, cardNo, creditCardId, expireYearMonth, expired, holderName, selected, sameWithBc001 }) {
      commit('setCardBrand', cardBrand);
      commit('setCardNo', cardNo);
      commit('setCreditCardId', creditCardId);
      commit('setExpireYearMonth', expireYearMonth);
      commit('setExpired', expired);
      commit('setHolderName', holderName);
      commit('setSelected', selected);
      commit('setSameWithBc001', sameWithBc001);
    },
    resetRequestData({commit}) {
      commit('resetOrderList');
      commit('setRequestDatacreditCardId', 0);
      commit('setWalletAmount', 0);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/n-selection.js